import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-signed-icon',
    templateUrl: './signed-icon.component.html',
    styleUrls: ['./signed-icon.component.css'],
    standalone: false
})
export class SignedIconComponent implements ICellRendererAngularComp {

  constructor() { }
  
  params: any;
  icon: string
  marked: boolean
  tooltip: string
  show = true
  agInit(params: any): void {
    this.params = params;

    switch (this.params.colDef.cellRendererParams){
      
      case 'TableReportsSign': 
        this.marked = this.params.data.signed
        this.icon = this.marked ? 'verified_user' : 'remove_moderator',
        this.tooltip = this.marked ? 'Documento firmado' : 'Documento no firmado'
      break;

      case 'CustomerVerification':
        this.marked  = Boolean(this.params.data.verification)        
        this.show = this.params.data.fromApp
        this.icon = 'verified'
        this.tooltip = this.marked ? this.params.data.verification.verified_by?.name + this.params.data.verification.verified_by?.lastName : 'No verificado'
      break;

    }
  }

  refresh(): boolean {
    return false;
  }

}
